/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `af` - Afrikaans * `ar` - Arabic * `ar-dz` - Algerian Arabic * `ast` - Asturian * `az` - Azerbaijani * `bg` - Bulgarian * `be` - Belarusian * `bn` - Bengali * `br` - Breton * `bs` - Bosnian * `ca` - Catalan * `ckb` - Central Kurdish (Sorani) * `cs` - Czech * `cy` - Welsh * `da` - Danish * `de` - German * `dsb` - Lower Sorbian * `el` - Greek * `en` - English * `en-au` - Australian English * `en-gb` - British English * `eo` - Esperanto * `es` - Spanish * `es-ar` - Argentinian Spanish * `es-co` - Colombian Spanish * `es-mx` - Mexican Spanish * `es-ni` - Nicaraguan Spanish * `es-ve` - Venezuelan Spanish * `et` - Estonian * `eu` - Basque * `fa` - Persian * `fi` - Finnish * `fr` - French * `fy` - Frisian * `ga` - Irish * `gd` - Scottish Gaelic * `gl` - Galician * `he` - Hebrew * `hi` - Hindi * `hr` - Croatian * `hsb` - Upper Sorbian * `hu` - Hungarian * `hy` - Armenian * `ia` - Interlingua * `id` - Indonesian * `ig` - Igbo * `io` - Ido * `is` - Icelandic * `it` - Italian * `ja` - Japanese * `ka` - Georgian * `kab` - Kabyle * `kk` - Kazakh * `km` - Khmer * `kn` - Kannada * `ko` - Korean * `ky` - Kyrgyz * `lb` - Luxembourgish * `lt` - Lithuanian * `lv` - Latvian * `mk` - Macedonian * `ml` - Malayalam * `mn` - Mongolian * `mr` - Marathi * `ms` - Malay * `my` - Burmese * `nb` - Norwegian Bokmål * `ne` - Nepali * `nl` - Dutch * `nn` - Norwegian Nynorsk * `os` - Ossetic * `pa` - Punjabi * `pl` - Polish * `pt` - Portuguese * `pt-br` - Brazilian Portuguese * `ro` - Romanian * `ru` - Russian * `sk` - Slovak * `sl` - Slovenian * `sq` - Albanian * `sr` - Serbian * `sr-latn` - Serbian Latin * `sv` - Swedish * `sw` - Swahili * `ta` - Tamil * `te` - Telugu * `tg` - Tajik * `th` - Thai * `tk` - Turkmen * `tr` - Turkish * `tt` - Tatar * `udm` - Udmurt * `ug` - Uyghur * `uk` - Ukrainian * `ur` - Urdu * `uz` - Uzbek * `vi` - Vietnamese * `zh-hans` - Simplified Chinese * `zh-hant` - Traditional Chinese
 */
export type LanguageEnum = 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'bg' | 'be' | 'bn' | 'br' | 'bs' | 'ca' | 'ckb' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant';

export const LanguageEnum = {
    Af: 'af' as LanguageEnum,
    Ar: 'ar' as LanguageEnum,
    ArDz: 'ar-dz' as LanguageEnum,
    Ast: 'ast' as LanguageEnum,
    Az: 'az' as LanguageEnum,
    Bg: 'bg' as LanguageEnum,
    Be: 'be' as LanguageEnum,
    Bn: 'bn' as LanguageEnum,
    Br: 'br' as LanguageEnum,
    Bs: 'bs' as LanguageEnum,
    Ca: 'ca' as LanguageEnum,
    Ckb: 'ckb' as LanguageEnum,
    Cs: 'cs' as LanguageEnum,
    Cy: 'cy' as LanguageEnum,
    Da: 'da' as LanguageEnum,
    De: 'de' as LanguageEnum,
    Dsb: 'dsb' as LanguageEnum,
    El: 'el' as LanguageEnum,
    En: 'en' as LanguageEnum,
    EnAu: 'en-au' as LanguageEnum,
    EnGb: 'en-gb' as LanguageEnum,
    Eo: 'eo' as LanguageEnum,
    Es: 'es' as LanguageEnum,
    EsAr: 'es-ar' as LanguageEnum,
    EsCo: 'es-co' as LanguageEnum,
    EsMx: 'es-mx' as LanguageEnum,
    EsNi: 'es-ni' as LanguageEnum,
    EsVe: 'es-ve' as LanguageEnum,
    Et: 'et' as LanguageEnum,
    Eu: 'eu' as LanguageEnum,
    Fa: 'fa' as LanguageEnum,
    Fi: 'fi' as LanguageEnum,
    Fr: 'fr' as LanguageEnum,
    Fy: 'fy' as LanguageEnum,
    Ga: 'ga' as LanguageEnum,
    Gd: 'gd' as LanguageEnum,
    Gl: 'gl' as LanguageEnum,
    He: 'he' as LanguageEnum,
    Hi: 'hi' as LanguageEnum,
    Hr: 'hr' as LanguageEnum,
    Hsb: 'hsb' as LanguageEnum,
    Hu: 'hu' as LanguageEnum,
    Hy: 'hy' as LanguageEnum,
    Ia: 'ia' as LanguageEnum,
    Id: 'id' as LanguageEnum,
    Ig: 'ig' as LanguageEnum,
    Io: 'io' as LanguageEnum,
    Is: 'is' as LanguageEnum,
    It: 'it' as LanguageEnum,
    Ja: 'ja' as LanguageEnum,
    Ka: 'ka' as LanguageEnum,
    Kab: 'kab' as LanguageEnum,
    Kk: 'kk' as LanguageEnum,
    Km: 'km' as LanguageEnum,
    Kn: 'kn' as LanguageEnum,
    Ko: 'ko' as LanguageEnum,
    Ky: 'ky' as LanguageEnum,
    Lb: 'lb' as LanguageEnum,
    Lt: 'lt' as LanguageEnum,
    Lv: 'lv' as LanguageEnum,
    Mk: 'mk' as LanguageEnum,
    Ml: 'ml' as LanguageEnum,
    Mn: 'mn' as LanguageEnum,
    Mr: 'mr' as LanguageEnum,
    Ms: 'ms' as LanguageEnum,
    My: 'my' as LanguageEnum,
    Nb: 'nb' as LanguageEnum,
    Ne: 'ne' as LanguageEnum,
    Nl: 'nl' as LanguageEnum,
    Nn: 'nn' as LanguageEnum,
    Os: 'os' as LanguageEnum,
    Pa: 'pa' as LanguageEnum,
    Pl: 'pl' as LanguageEnum,
    Pt: 'pt' as LanguageEnum,
    PtBr: 'pt-br' as LanguageEnum,
    Ro: 'ro' as LanguageEnum,
    Ru: 'ru' as LanguageEnum,
    Sk: 'sk' as LanguageEnum,
    Sl: 'sl' as LanguageEnum,
    Sq: 'sq' as LanguageEnum,
    Sr: 'sr' as LanguageEnum,
    SrLatn: 'sr-latn' as LanguageEnum,
    Sv: 'sv' as LanguageEnum,
    Sw: 'sw' as LanguageEnum,
    Ta: 'ta' as LanguageEnum,
    Te: 'te' as LanguageEnum,
    Tg: 'tg' as LanguageEnum,
    Th: 'th' as LanguageEnum,
    Tk: 'tk' as LanguageEnum,
    Tr: 'tr' as LanguageEnum,
    Tt: 'tt' as LanguageEnum,
    Udm: 'udm' as LanguageEnum,
    Ug: 'ug' as LanguageEnum,
    Uk: 'uk' as LanguageEnum,
    Ur: 'ur' as LanguageEnum,
    Uz: 'uz' as LanguageEnum,
    Vi: 'vi' as LanguageEnum,
    ZhHans: 'zh-hans' as LanguageEnum,
    ZhHant: 'zh-hant' as LanguageEnum
};